import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApplicationStep2 } from "./../../models/classes/ApplicationStep2.class";


export interface ApplicationStep2States {
  isCompleted:boolean,
  formData:ApplicationStep2,
}

const initialState: ApplicationStep2States = {
  isCompleted:false,
  formData: new ApplicationStep2()
};


const ApplicationStep2Slice = createSlice({
  name:"Application Step 2 Slice",
  initialState,
  reducers:{
    updateFormData: (state, action: PayloadAction<ApplicationStep2>) => {
      state.formData = action.payload;
    },
    setCompleted: (state, action: PayloadAction<boolean>) => {
      state.isCompleted = action.payload;
    },
    resetFormData: (state)=>{
      state.formData = new ApplicationStep2();
    }
  },
  extraReducers: {}
});


export const { updateFormData, setCompleted, resetFormData } = ApplicationStep2Slice.actions;

export default ApplicationStep2Slice.reducer;